import { defineMessages } from 'react-intl';

export const ratingTagsMessages = defineMessages({
  headlineContra: {
    defaultMessage: 'Nachteile',
    id: 'ratings.productTags.headline.contra',
  },
  headlinePro: {
    defaultMessage: 'Vorteile',
    id: 'ratings.productTags.headline.pro',
  },
});
